<template>
  <div id="el-box-number">
    <div class="tit-rit">箱号管理</div>
    <div class="el-serch-box">
      <div class="el-serch-waper">
        <el-input
          v-model="serch_inputOne"
          clearable
          :placeholder="placeholder"
          :style="widths"
          prefix-icon="el-icon-search"
          @keyup.enter.native="serchTableData()"
        >
          <template slot="prepend">集装箱号</template>
        </el-input>
        <el-input
          v-model="serch_inputTwo"
          clearable
          :placeholder="placeholder"
          :style="widths"
          prefix-icon="el-icon-search"
          @keyup.enter.native="serchTableData()"
        >
          <template slot="prepend">始发站</template>
        </el-input>
        <el-input
          v-model="serch_inputThree"
          clearable
          :placeholder="placeholder"
          :style="widths"
          prefix-icon="el-icon-search"
          @keyup.enter.native="serchTableData()"
        >
          <template slot="prepend">目的站</template>
        </el-input>
      </div>
    </div>
    <div class="el-top-program">
      <el-popover placement="bottom" width="300" v-model="visible">
        <div style="text-align: right; margin: 0">
          <el-input
            :placeholder="addPlaceholder"
            v-model="addCaseNum"
            clearable
            style="width: 300px; margin-bottom: 20px"
            @keyup.enter.native="addTableData"
          >
            <template slot="prepend">箱号：</template>
          </el-input>
          <el-input
            :placeholder="addPlacemail"
            v-model="addEmailNum"
            clearable
            style="width: 300px; margin-bottom: 20px"
            @keyup.enter.native="addTableData"
          >
            <template slot="prepend">邮箱：</template>
          </el-input>
          <el-button type="primary" size="mini" @click="addTableData"
            >添加</el-button
          >
          <el-button size="mini" type="text" @click="closeTableData"
            >取消</el-button
          >
        </div>
        <el-button slot="reference" type="success" icon="el-icon-plus"
          >添加箱号 / 邮箱</el-button
        >
      </el-popover>

      <el-popover placement="bottom" width="200" v-model="visibles">
        <p style="font-size: 14px; color: #f56c6c; padding-bottom: 10px">
          确定要删除选中的箱号吗？全部删除后不可恢复！
        </p>
        <div style="text-align: right; margin: 0">
          <el-button
            type="primary"
            size="mini"
            :disabled="this.multipleSelection.length === 0"
            @click="delAllcaseNum(multipleSelection)"
            >确定</el-button
          >
          <el-button size="mini" type="text" @click="visibles = false"
            >取消</el-button
          >
        </div>
        <el-button
          slot="reference"
          type="warning"
          icon="el-icon-delete"
          :disabled="this.multipleSelection.length === 0"
          >批量删除</el-button
        >
      </el-popover>

      <el-button-group>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="serchTableData()"
          :disabled="!serch_inputOne && !serch_inputTwo && !serch_inputThree"
          >关键字搜索</el-button
        >
        <el-button type="info" icon="el-icon-close" @click="infoTableData"
          >重置</el-button
        >
      </el-button-group>
    </div>
    <div class="el-table-waper">
      <el-table
        :data="boxTableNumber"
        tooltip-effect="dark"
        border
        stripe
        fit
        @selection-change="handleSelectionChange"
        style="width: 100%"
        :header-cell-style="{
          color: '#696969',
          'border-bottom': '1px solid #fff',
          'font-size': '16px',
          'text-align': 'center',
          'background-color': '#DBE6FF',
        }"
        :cell-style="{
          'text-align': 'center',
        }"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 箱号 -->
        <el-table-column prop="case_no" label="箱号">
          <template slot-scope="scope">
            <el-input
              size="small"
              v-model="editCaseNums"
              style="width: 127px"
              v-if="editValue.case_no == scope.row.case_no"
              @keyup.enter.native="editCaseNum"
              @blur="editCaseNum"
            ></el-input>
            <span
              class="el-case-Color"
              v-else
              @click="cliSearch(scope.row.case_no)"
              >{{ scope.row.case_no }}</span
            >
          </template>
        </el-table-column>
        <!-- 箱号 -->
        <el-table-column prop="startStation" label="始发站"> </el-table-column>
        <el-table-column prop="endStation" label="目的站"> </el-table-column>
        <!-- <el-table-column prop="ETA" label="ETA"> </el-table-column>
        <el-table-column prop="ETD" label="ETD"> </el-table-column> -->
        <!-- 邮箱 -->
        <el-table-column prop="case_email" label="邮箱" width="180">
          <template slot-scope="scope">
            <el-input
              size="small"
              v-model="editEmailNums"
              style="width: 150px"
              v-if="editValue.case_email == scope.row.case_email"
              @keyup.enter.native="editCaseNum"
              @blur="editCaseNum"
            ></el-input>
            <span class="el-case-Color2" v-else>
              {{ scope.row.case_email }}
            </span>
          </template>
        </el-table-column>
        <!-- 邮箱 -->
        <el-table-column width="130" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="handleEdit(scope.$index, scope.row)"
            ></el-button>
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-delete"
              @click="handleDelete(scope.$index, scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="el-table-fy">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pagesize"
          :total="total"
          @current-change="serchTableData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Boxnumber",
  data() {
    return {
      visible: false,
      visibles: false,
      srce: "",
      addCaseNum: "", //添加箱号
      addEmailNum: "", //添加邮箱
      editCaseNums: "", //编辑箱号
      editEmailNums: "", //编辑邮箱
      saveDisable: true,
      addPlaceholder: "例：ABCD0000000",
      addPlacemail: "例：xxx@xxx.com",
      placeholder: "请输入搜索内容",
      editValue: "",
      caseId: "",
      serch_inputOne: "",
      serch_inputTwo: "",
      serch_inputThree: "",
      widths: {
        width: "316px",
      },
      boxTableNumber: [
        {
          case_no: "--",
          startStation: "--",
          endStation: "--",
          ETA: "--",
          ETD: "--",
          case_email: "--",
        },
      ],
      add_caseNum: "",
      multipleSelection: [], //表格选中数据
      total: null,
      pagesize: 10, //每页显示条数
      currpage: 1, //页码
    };
  },
  mounted() {
    this.getTableData();
  },
  //任意一个输入框是否输入内容，控制搜索按钮是否可用
  computed: {
    isSerchTable() {
      return (
        !!this.serch_inputOne &&
        !!this.serch_inputTwo &&
        !!this.serch_inputThree
      );
    },
  },
  methods: {
    //获取表格数据
    getTableData() {
      this.openLoading();
      //判断三个搜索框是否有数据
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("CaseNo/index", {
          token: tokens,
          curPage: this.currpage,
          pageNum: this.pagesize,
        })
        .then((res) => {
          this.closeLoading(this.openLoading());
          this.boxTableNumber = res.data.data;
          this.total = res.data.count;
        })
        .catch((err) => {
          console.log("服务器错误！");
        });
    },
    //添加表格数据
    addTableData() {
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("CaseNo/addCaseNo", {
          token: tokens,
          case_no: this.addCaseNum,
          case_email: this.addEmailNum,
        })
        .then((res) => {
          if (this.addCaseNum != "" && this.addCaseNum != null) {
            this.visible = false;
            this.addCaseNum = "";
            this.addEmailNum = "";
            this.getTableData();
            //添加完毕后刷新整个页面返回
            this.$message({
              message: res.data.msg,
              type: "success",
              offset: 200,
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
              offset: 200,
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: res.data.msg,
            type: "warning",
            offset: 200,
          });
        });
    },
    //表格行内编辑
    handleEdit(index, row) {
      this.editValue = row;
      this.caseId = row.id;
      this.editCaseNums = row.case_no;
      this.editEmailNums = row.case_email;
      // console.log(this.editValue);
    },
    editCaseNum() {
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("CaseNo/addCaseNo", {
          token: tokens,
          case_id: this.caseId,
          case_no: this.editCaseNums,
          case_email: this.editEmailNums,
        })
        .then((res) => {
          this.$router.go(0);
          this.getTableData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //关闭添加浮窗
    closeTableData() {
      this.visible = false;
      this.addCaseNum = "";
      this.addEmailNum = "";
    },
    //复选框获取选中数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //选中表格全部删除
    delAllcaseNum() {
      let tokens = localStorage.getItem("token");
      //获取所有选中行的id组成的字符串，以逗号分隔
      let ids = this.multipleSelection.map((item) => item.id).join();
      this.$axios
        .post("CaseNo/delCaseNo", {
          token: tokens,
          case_id: ids,
        })
        .then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
            offset: 200,
          });
          //清空选中
          this.multipleSelection = [];
          //关闭确认框
          this.visibles = false;
          //当前页删除完毕后，跳转到前一页
          const totalPage = Math.ceil((this.total - 10) / this.pagesize); // 总页数
          this.currpage = this.currpage > totalPage ? totalPage : this.currpage;
          this.currpage = this.currpage < 1 ? 1 : this.currpage; //页码小于1时停留最后一页
          //删除后重新获取表格数据
          this.getTableData();
        })
        .catch((err) => {
          console.log("删除失败");
        });
    },
    //行内表格删除
    handleDelete(index, row) {
      let tokens = localStorage.getItem("token");
      if (!this.multipleSelection[0]) {
        this.$message({
          message: "请选中当前数据进行删除！",
          type: "warning",
          offset: 200,
        });
        return;
      }
      this.$axios
        .post("CaseNo/delCaseNo", {
          token: tokens,
          case_id: this.multipleSelection[0].id,
        })
        .then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
            offset: 200,
          });
          //清空选中
          this.multipleSelection = [];
          //当前页删除完毕后，跳转到前一页
          const totalPage = Math.ceil((this.total - 1) / this.pagesize); // 总页数
          this.currpage = this.currpage > totalPage ? totalPage : this.currpage;
          this.currpage = this.currpage < 1 ? 1 : this.currpage; //页码小于1时停留最后一页
          //删除后重新获取表格数据
          this.getTableData();
        })
        .catch((err) => {
          console.log("服务器错误！");
        });
    },
    //表格分页搜索
    serchTableData(cpage) {
      //serch_input
      this.openLoading();
      let tokens = localStorage.getItem("token");
      this.currpage = cpage;
      this.$axios
        .post("CaseNo/index", {
          token: tokens,
          case_no: this.serch_inputOne,
          startStation: this.serch_inputTwo,
          endStation: this.serch_inputThree,
          pageNum: this.pagesize,
          curPage: this.currpage,
        })
        .then((res) => {
          this.closeLoading(this.openLoading());
          this.boxTableNumber = res.data.data;
          this.total = res.data.count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //重置搜索
    infoTableData() {
      this.serch_inputOne = "";
      this.serch_inputTwo = "";
      this.serch_inputThree = "";
      this.disabled = "disabled";
      this.getTableData();
    },
    //延时loading
    openLoading() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中,请稍后......",
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,0.1)",
      });
      return loading;
    },
    closeLoading(loading) {
      loading.close();
    },
    //点击跳转到搜索页面并传值搜索
    cliSearch(srce) {
      let routeData = this.$router.resolve({
        path: "/Main",
        query: {
          srce: srce,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<<style>
  .el-table td, .el-table th {
    padding: 6px 0 !important;
  }
</style>
<style  scoped>
@import "./coms/user.css";
</style>



// WEBPACK FOOTER //
// src/components/user/box_number.vue